import { calculateKnnClassifier } from '../domain/knn-provider';
import { useKnnStore } from '../dal/knn-store';

const NaiveBayesClassifierView = () => {

    const params = useKnnStore(store => store.params);
    const distance = useKnnStore(store => store.distance);

    const results = calculateKnnClassifier(params, distance);

    return (
        <div className="grid grid-cols-[auto_auto] gap-6 items-start">

            <table>
                <thead>
                <tr>
                    <th className="border p-4 bg-slate-100">&nbsp;</th>

                    {
                        params.titles.map((title, i) => {
                            return (
                                <th key={ `title-${ i }` } className="border p-4 bg-slate-100">{ title }</th>
                            )
                        })
                    }

                    <th className="border p-4 bg-yellow-100">{ params.targetName }</th>

                    <th className="border p-4 bg-slate-100">Distance</th>

                    <th className="border p-4 bg-slate-100">Included?</th>
                </tr>
                </thead>
                <tbody>
                {
                    params.rows.map((row, i) => {

                        const distanceItem = results.distances.find(item => item.rowIndex === i);

                        return (
                            <tr key={ `row-${ i }` }>
                                <td className="border p-4 bg-slate-100">{ i + 1 }</td>

                                {
                                    row.map((cell, j ) => {
                                        return (
                                            <td key={ `cell-${ j }` } className="border p-4">{ cell }</td>
                                        )
                                    })
                                }

                                <td className="border p-4 bg-yellow-50">{ params.targetValues[i] }</td>

                                <td className="border p-4">
                                    { distanceItem?.calculations }
                                </td>

                                <td className="border p-4">
                                    { distanceItem?.isInKRange ? '✅' : '' }
                                </td>
                            </tr>
                        )
                    })
                }
                </tbody>
            </table>

            <div>
                {
                    results.targetResults.map((res, i) => {
                        return (
                            <div key={ `res-${ i }` }>
                                { res[0] } : { res[1] }
                            </div>
                        )
                    })
                }

                <hr className="my-4" />

                <div className="text-blue-700">{ results.maxProperty }</div>
            </div>
        </div>
    )
};

export default NaiveBayesClassifierView;